module.exports = __webpack_public_path__ + "img/爱情.714c18f3.gif";